import { FC } from "react";
import { PharmacyResultsContentItemProps } from "./PharmacyResultsContentItem.props";
import styles from "./PharmacyResultsContentItem.module.scss";

const PharmacyResultsContentItem: FC<PharmacyResultsContentItemProps> = ({
  pharmacyName,
  distance,
  address,
  cityStateZip,
  children,
  testId,
}: PharmacyResultsContentItemProps) => {
  return (
    <div className={styles.ContentWrapper} data-testid={testId}>
      {children}
      <div className={styles.CardMainContent}>
        <div className={styles.PharmacyInformation}>
          <span className={styles.PharmacyName} data-testid={pharmacyName}>
            {pharmacyName}
          </span>
          <span className={styles.LocationInformation} data-testid={`${pharmacyName}-location`}>
            {distance} miles | {address}
          </span>
          <span className={styles.LocationInformation} data-testid={`${pharmacyName}-zip`}>
            {cityStateZip}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PharmacyResultsContentItem;
